import Principal from './logar.svelte'; 

const app = new Principal({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;